module.exports = __webpack_public_path__ + "static/media/30OIOS10.abb22827.jpg";